import { HttpClient } from "./http";

class Auth extends HttpClient {
    constructor() {
        super();
    }

    login(data: any) {
        return this.HTTP.post('/auth/login', data)
    }

    logout() {
        return this.HTTP.delete('/auth/logout')
    }
}

export const AuthService = new Auth();
